/**
 * Fordítási idejű kapcsolók olyan funkciókhoz, amelyek a kódban maradnak, de
 * jelenleg nem jelennek meg sem az élő oldalon, sem az adminban.
 */

/**
 * Hitel kalkulátor (lakás oldali havi törlesztés-számoló).
 *
 * A megrendelő kérésére elrejtve: nem jelenik meg a publikus lakás oldalakon,
 * és az admin → Oldal beállítások alatt sincs „Hitel kalkulátor" szekció. A
 * háttérben MINDEN megmarad (a `MortgageCalculator` komponens, az MNB
 * alapkamatot lekérő `/api/mortgage/rates` végpont és a `siteSettings.mortgage`
 * beállítás-blokk), így ha újra kell, elég ezt `true`-ra állítani — nincs
 * szükség új fejlesztésre.
 *
 * Helyette a `MortgageAdvisorBox` (hitelügyintéző-doboz + visszahívás-kérő
 * űrlap) jelenik meg a főoldalon és a lakás oldalakon.
 */
export const MORTGAGE_CALCULATOR_ENABLED = false;
